import React from 'react';
import { connect } from 'react-redux';
import { compose, lifecycle } from 'recompose';
import { loadPortfolio, createCategory, updateWidget, addWidget } from '../actions';
import { EditorDialogue } from '../../editor/components/Editor';
import { withEditorWidget } from '../../editor/hoc/editor';

import { FlatButton } from 'material-ui';

import NetflixGallery, { WidgetPreview as WP2 } from 'dash-front/editor/components/NetflixGallery';

const SaveButton = withEditorWidget(FlatButton);

class WidgetPortfolio extends React.Component {
    state = {
        edit: null,
        addWidgetTo: null,
    };
    actionsForEdit = [
        <SaveButton
            key="save"
            label="save"
            primary
            onClick={(e, { widgetId, widgetProps }) => {
                this.props
                    .updateWidget(this.props.portfolio.type, this.state.edit._id, {
                        wid: widgetId,
                        props: widgetProps,
                    })
                    .then(() => {
                        this.setState({ edit: null });
                    });
            }}
        />,
        <FlatButton
            key="close"
            label="close"
            primary
            onClick={() => {
                this.setState({ edit: null });
            }}
        />,
    ];

    actionsForCreate = [
        <SaveButton
            key="save"
            label="save"
            primary
            onClick={(e, { widgetId, widgetProps }) => {
                this.props
                    .addWidget(this.props.portfolio.type, this.state.addWidgetTo, {
                        wid: widgetId,
                        props: widgetProps,
                    })
                    .then(() => {
                        this.setState({ addWidgetTo: null });
                    });
            }}
        />,
        <FlatButton
            key="close"
            label="close"
            primary
            onClick={() => {
                this.setState({ addWidgetTo: null });
            }}
        />,
    ];

    render = () => {
        const { portfolio, createCategory } = this.props;
        const { edit } = this.state;
        if (!portfolio) return <div>...</div>;

        return (
            <div style={{ display: 'flex', flexDirection: 'column', flexGrow: 1 }}>
                <h1>
                    Portfolio{' '}
                    <FlatButton
                        label="Create group"
                        onClick={() => {
                            const name = prompt('name');
                            // alert(name);
                            createCategory(portfolio.type, name);
                        }}
                    />
                </h1>

                {portfolio.categories.map(category => (
                    <div key={category}>
                        <h1>
                            {category}
                            <FlatButton
                                label="Add widget"
                                onClick={() => {
                                    this.setState({
                                        addWidgetTo: category,
                                        addWidgetTitle: `Add widget to ${category}`,
                                    });
                                }}
                            />
                        </h1>

                        <NetflixGallery
                            key={category + '_'}
                            list={portfolio.widgets.filter(w => w.category === category)}
                            renderKey={(w, props) => `${w._id}_`}
                            renderFullView={w => <h1>{w.id}</h1>}
                            renderItem={(w, props) => (
                                <WP2
                                    key={w._id}
                                    {...props}
                                    widget={w}
                                    allowZoom
                                    widgetId={w.wid}
                                    props={{ ...w.props }}
                                    wdpcache="state"
                                    onClick={() => {
                                        this.setState({ edit: w });
                                    }}
                                />
                            )}
                        />
                    </div>
                ))}

                {edit && (
                    <EditorDialogue
                        key={edit.wid}
                        open={edit}
                        widgetId={edit.wid}
                        widgetProps={edit.props}
                        actions={this.actionsForEdit}
                        onChange={(widget, params) => {
                            console.log('ON CHANGE', widget, params);
                        }}
                    />
                )}
                <EditorDialogue
                    open={this.state.addWidgetTo}
                    title={this.state.addWidgetTitle}
                    allowChangeWidget
                    actions={this.actionsForCreate}
                />
            </div>
        );
    };
}

const mapStateToProps = ({ user, portfolio }, { params }) => {
    return {
        user,
        portfolio: portfolio.byIds[params.type],
    };
};

const mapDispatchToProps = { loadPortfolio, createCategory, updateWidget, addWidget };

export default compose(
    connect(
        mapStateToProps,
        mapDispatchToProps,
    ),
    lifecycle({
        componentWillReceiveProps() {},
        componentDidMount() {
            this.props.loadPortfolio(this.props.params.type);
        },
    }),
)(WidgetPortfolio);



/** WEBPACK FOOTER **
 ** ../src/dash/front/portfolio/components/WidgetPortfolio.js
 **/